function sleep(ms){
  return new Promise(resolve=>setTimeout(resolve,ms))
}

const subSleep = async (ms)=>{ await sleep(ms)}

export {subSleep}